module.exports = __webpack_public_path__ + "static/img/empty-icon.f522b248.svg";